
import axios from "axios"
import encryptData from "../utils/encryption";
import { AuthContext } from "../contexts/AuthContext";
import { useContext } from "react";


const URL = process.env.REACT_APP_MASTER_URL;
// const companyCode = sessionStorage.getItem("CompanyCode");
// const roleCode = sessionStorage.getItem("roleCode");

// const companyCode = context.company_code;
// const roleCode = context.role_code;

export async function authenticate(user) {


  //let email = encryptData(user, "enc");


  // let url = `${URL}/authenticate/${encodeURIComponent(email)}`;
  // console.log("encodeURIComponent", encodeURIComponent(email));

  // console.log(" url123 ", url);
  // let response = await axios.get(url);

  let value = encryptData(user, "enc");
  let url = `${URL}/enquiry/authenticate`;

  // axios
  //   .post(url, { body: value }, {
  //   }
  //   ).then((response) => {
  //     return response.data;
  //   });


    const response = await axios.post(url
      ,{ body: value }
    )
    return response.data;

  // console.log("response", response);

}

export const getUserRoleMenuMapping = async (roleCode, companyCode) => {
  console.log(" under getUserRoleMenuMapping user Service ", " role_code ", roleCode, " companyCode ", companyCode)
  let url = `${URL}/user/role/${roleCode}`;
  console.log(" url ", url);
  const response = await axios.get(url, {
    headers: {
      "companyCode": companyCode
    }
  })
  console.log(" response getUserRoleMenuMapping ", response);
  return response.data;
};

export async function getRoleMenuMapping() {
  const response = await axios.get(URL + "/getrolemenumapping");
  return response.data;
}


// export async function getAllMenus() {
//   let url = URL + "/getallmenu";
//   const response = await axios.get(url, {
//     headers: {
//       "companyCode": companyCode,
//     }
//   })
//   return response.data;
// }

// export async function getAllRoles() {
//   let url = URL + "/getallroles";
//   const response = await axios.get(url, {
//     headers: {
//       "companyCode": companyCode,
//     }
//   })
//   return response.data;
// }